/*!
    * Based on articles on
    * https://gomakethings.com
    */

    var drawer = function () {

      /**
      * Element.closest() polyfill
      * https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
      */
      if (!Element.prototype.closest) {
        if (!Element.prototype.matches) {
          Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
        }
        Element.prototype.closest = function (s) {
          var el = this;
          var ancestor = this;
          if (!document.documentElement.contains(el)) return null;
          do {
            if (ancestor.matches(s)) return ancestor;
            ancestor = ancestor.parentElement;
          } while (ancestor !== null);
          return null;
        };
      }


      // Elements inside a drawer that can receive keyboard focus
      //
      var focusableSelector = 'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])';


      // Trap Focus 
      // https://hiddedevries.nl/en/blog/2017-01-29-using-javascript-to-trap-focus-in-an-element
      //
      function trapFocus(element) {
        var focusableEls = element.querySelectorAll(focusableSelector);
        var firstFocusableEl = focusableEls[0];  
        var lastFocusableEl = focusableEls[focusableEls.length - 1];
        var KEYCODE_TAB = 9;

        function trapFocusHandler(e) {
          var isTabPressed = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB);

          if (!isTabPressed) { 
            return; 
          }

          if ( e.shiftKey ) /* shift + tab */ {
            if (document.activeElement === firstFocusableEl) {
              lastFocusableEl.focus();
                e.preventDefault();
              }
            } else /* tab */ {
            if (document.activeElement === lastFocusableEl) {
              firstFocusableEl.focus();
                e.preventDefault();
              }
            }
        }

        // Drop the handler left by any previous open so listeners cannot accumulate
        if (element.drawerTrapFocusHandler) {
          element.removeEventListener('keydown', element.drawerTrapFocusHandler);
        }
        element.drawerTrapFocusHandler = trapFocusHandler;
        element.addEventListener('keydown', trapFocusHandler);
      }       


      //
      // Settings
      //
      var settings = {
        speedOpen: 50,
        speedClose: 350,
        activeClass: 'is-active',
        visibleClass: 'is-visible',
        selectorTarget: '[data-drawer-target]',
        selectorTrigger: '[data-drawer-trigger]',
        selectorClose: '[data-drawer-close]',
      };


      //
      // Methods
      //

      // Toggle accessibility
      var toggleAccessibility = function (event) {
        if (event.getAttribute('aria-expanded') === 'true') {
          event.setAttribute('aria-expanded', false);
        } else {
          event.setAttribute('aria-expanded', true);
        }   
      };

      // Open Drawer
      var openDrawer = function (trigger) {

        // Find target
        var target = document.getElementById(trigger.getAttribute('aria-controls'));

        // Remember what had focus before opening so it can be restored on close
        target.drawerReturnFocusEl = document.activeElement;
        target.drawerTriggerEl = trigger;

        // Expose the drawer as a modal dialog to assistive technology
        target.setAttribute('role', 'dialog');
        target.setAttribute('aria-modal', 'true');
        if (!target.getAttribute('aria-labelledby') && !target.getAttribute('aria-label')) {
          var heading = target.querySelector('h1, h2, h3, h4, h5, h6');
          if (heading) {
            if (!heading.id) {
              heading.id = (target.id || 'drawer') + '-title';
            }
            target.setAttribute('aria-labelledby', heading.id);
          } else {
            target.setAttribute('aria-label', 'Menu');
          }
        }

        // Make it active
        target.classList.add(settings.activeClass);

        // Make body overflow hidden so it's not scrollable
        document.documentElement.style.overflow = 'hidden';

        // Toggle accessibility
        toggleAccessibility(trigger);

        // Make it visible
        setTimeout(function () {
          target.classList.add(settings.visibleClass);
          trapFocus(target);

          // Move focus into the drawer: the close button if there is one, otherwise the first focusable element
          var focusTarget = target.querySelector('button' + settings.selectorClose) || target.querySelector(focusableSelector);
          if (focusTarget) {
            focusTarget.focus();
          }
        }, settings.speedOpen); 

      };

      // Close Drawer
      var closeDrawer = function (event) {

        // Find target
        var closestParent = event.closest(settings.selectorTarget),
          childrenTrigger = document.querySelector('[aria-controls="' + closestParent.id + '"');

        // Make it not visible
        closestParent.classList.remove(settings.visibleClass);

        // Remove body overflow hidden
        document.documentElement.style.overflow = '';

        // Toggle accessibility
        toggleAccessibility(childrenTrigger);

        // Return focus to the element that opened the drawer
        var returnFocusEl = closestParent.drawerReturnFocusEl;
        if (!returnFocusEl || returnFocusEl === document.body || !document.documentElement.contains(returnFocusEl)) {
          returnFocusEl = closestParent.drawerTriggerEl || childrenTrigger;
        }
        if (returnFocusEl && typeof returnFocusEl.focus === 'function') {
          returnFocusEl.focus();
        }

        // Make it not active
        setTimeout(function () {
          closestParent.classList.remove(settings.activeClass);
        }, settings.speedClose);             

      };

      // Click Handler
      var clickHandler = function (event) {

        // Find elements
        var toggle = event.target,
          open = toggle.closest(settings.selectorTrigger),
          close = toggle.closest(settings.selectorClose);

        // Open drawer when the open button is clicked
        if (open) {
          openDrawer(open);
        }

        // Close drawer when the close button (or overlay area) is clicked
        if (close) {
          closeDrawer(close);
        }

        // Prevent default link behavior
        if (open || close) {
          event.preventDefault();
        }

      };

      // Keydown Handler, handle Escape button
      var keydownHandler = function (event) {

        if (event.key === 'Escape' || event.keyCode === 27) {

          // Find all possible drawers
          var drawers = document.querySelectorAll(settings.selectorTarget),
            i;

          // Find active drawers and close them when escape is clicked
          for (i = 0; i < drawers.length; ++i) {
            if (drawers[i].classList.contains(settings.activeClass)) {
              closeDrawer(drawers[i]);
            }
          }

        }

      };


      //
      // Inits & Event Listeners
      //
      document.addEventListener('click', clickHandler, false);
      document.addEventListener('keydown', keydownHandler, false);


    };

    drawer();